const howToSteps = [
  "Open the template and review the starting frame.",
  "Adjust the image or settings before generation if needed.",
  "Generate a short clip and reuse the setup for more variations.",
];

const baseIntro =
  "Use this adult-only template as a starting point for short AI video creation. Open the setup, adjust the frame if needed, and generate from a scene that is already structured for motion.";

export const videoTemplates = [
  {
    slug: "pussy-fuck",
    collectionId: null,
    title: "Pussy Fuck AI Video Template",
    description:
      "Use the Pussy Fuck AI video template in Fapify to start from a proven adult AI setup, refine the frame, and generate a short clip.",
    h1: "Pussy Fuck AI Video Template",
    intro: baseIntro,
    howToSteps,
    keywords: [
      "pussy fuck ai",
      "ai porn video template",
      "ai video template",
      "nsfw ai video",
    ],
    relatedSlugs: ["pov-blowjob", "cowgirl-ride", "bedroom-tease"],
  },
  {
    slug: "pov-blowjob",
    collectionId: null,
    title: "POV Blowjob AI Video Template",
    description:
      "Use the POV Blowjob AI video template in Fapify to start from a proven adult AI setup, refine the frame, and generate a short clip.",
    h1: "POV Blowjob AI Video Template",
    intro: baseIntro,
    howToSteps,
    keywords: [
      "pov blowjob ai",
      "ai porn video template",
      "ai video template",
      "nsfw ai video",
    ],
    relatedSlugs: ["pussy-fuck", "cowgirl-ride", "bedroom-tease"],
  },
  {
    slug: "cowgirl-ride",
    collectionId: null,
    title: "Cowgirl Ride AI Video Template",
    description:
      "Use the Cowgirl Ride AI video template in Fapify to start from a proven adult AI setup, refine the frame, and generate a short clip.",
    h1: "Cowgirl Ride AI Video Template",
    intro: baseIntro,
    howToSteps,
    keywords: [
      "cowgirl ride ai",
      "ai porn video template",
      "ai video template",
      "nsfw ai video",
    ],
    relatedSlugs: ["pussy-fuck", "pov-blowjob", "bedroom-tease"],
  },
  {
    slug: "bedroom-tease",
    collectionId: null,
    title: "Bedroom Tease AI Video Template",
    description:
      "Use the Bedroom Tease AI video template in Fapify to start from a proven adult AI setup, refine the frame, and generate a short clip.",
    h1: "Bedroom Tease AI Video Template",
    intro: baseIntro,
    howToSteps,
    keywords: [
      "bedroom tease ai",
      "ai porn video template",
      "ai video template",
      "nsfw ai video",
    ],
    relatedSlugs: ["pussy-fuck", "pov-blowjob", "cowgirl-ride"],
  },
];

export const videoTemplatesBySlug = videoTemplates.reduce((acc, template) => {
  acc[template.slug] = template;
  return acc;
}, {});
